import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { Lang } from '@app/i18n';
import { ChangePasswordValue } from '../models';
import { UserValue } from '../models/user.value';

export const userManagementActions = createActionGroup({
    source: 'User Management',
    events: {
        'Change Password': props<{ value: ChangePasswordValue }>(),
        'Change Password Success': emptyProps(),
        'Change Password Error': emptyProps(),

        'Change Language': props<{ value: Lang }>(),
        'Change Language Success': props<{ value: Lang }>(),
        'Change Language Error': emptyProps(),

        'Edit User': props<{ value: UserValue }>(),
        'Edit User Success': props<{ value: UserValue }>(),
        'Edit User Error': props<{ errorResponse: HttpErrorResponse }>(),

        Clear: emptyProps(),
        'Clear Saved': emptyProps(),
    },
});
